/**
 * File navigation.js.
 * ハンバーガーメニュー開閉 + デスクトップナビドロップダウン制御
 */
( function () {
	const menuOpen    = document.getElementById( 'menuOpen' );
	const menuClose   = document.getElementById( 'closeMenu' );
	const menuOverlay = document.getElementById( 'menuOverlay' );
	const menuContent = document.getElementById( 'menuContent' );

	function openMenu() {
		if ( ! menuContent ) return;
		menuContent.classList.add( 'active' );
		menuContent.setAttribute( 'aria-hidden', 'false' );
		if ( menuOverlay ) menuOverlay.classList.add( 'active' );
		if ( menuOpen ) menuOpen.setAttribute( 'aria-expanded', 'true' );
		document.documentElement.style.overflow = 'hidden';
		document.body.style.overflow = 'hidden';
	}

	function closeMenu() {
		if ( ! menuContent ) return;
		menuContent.classList.remove( 'active' );
		menuContent.setAttribute( 'aria-hidden', 'true' );
		if ( menuOverlay ) menuOverlay.classList.remove( 'active' );
		if ( menuOpen ) menuOpen.setAttribute( 'aria-expanded', 'false' );
		document.documentElement.style.overflow = '';
		document.body.style.overflow = '';
	}

	if ( menuOpen )    menuOpen.addEventListener( 'click', openMenu );
	if ( menuClose )   menuClose.addEventListener( 'click', closeMenu );
	if ( menuOverlay ) menuOverlay.addEventListener( 'click', closeMenu );

	// ESCキーで閉じる
	document.addEventListener( 'keydown', function ( e ) {
		if ( e.key === 'Escape' ) closeMenu();
	} );

	// デスクトップナビ: ドロップダウン hover（150ms デバウンス）
	document.querySelectorAll( '.has-dropdown' ).forEach( function ( item ) {
		let timer;
		const dropdown = item.querySelector( '.head-dropdown' );
		if ( ! dropdown ) return;

		function showDropdown() {
			clearTimeout( timer );
			dropdown.classList.remove( 'drop-right' );
			dropdown.style.visibility = 'hidden';
			dropdown.classList.add( 'open' );
			if ( dropdown.getBoundingClientRect().right > window.innerWidth - 8 ) {
				dropdown.classList.add( 'drop-right' );
			}
			dropdown.style.visibility = '';
			item.classList.add( 'open' );
		}

		function hideDropdown() {
			timer = setTimeout( function () {
				dropdown.classList.remove( 'open' );
				item.classList.remove( 'open' );
			}, 150 );
		}

		item.addEventListener( 'mouseenter', showDropdown );
		item.addEventListener( 'mouseleave', hideDropdown );
		dropdown.addEventListener( 'mouseenter', function () { clearTimeout( timer ); } );
		dropdown.addEventListener( 'mouseleave', hideDropdown );
	} );
}() );

// ヘッダーfixed追従・パンくず非表示
( function () {
	const masthead = document.getElementById( 'masthead' );
	if ( ! masthead ) return;

	let scrollThreshold = masthead.offsetHeight;

	window.addEventListener( 'resize', function () {
		if ( ! masthead.classList.contains( 'is-sticky' ) ) {
			scrollThreshold = masthead.offsetHeight;
			document.body.style.paddingTop = '';
		}
	}, { passive: true } );

	window.addEventListener( 'scroll', function () {
		if ( window.scrollY >= scrollThreshold ) {
			if ( ! masthead.classList.contains( 'is-sticky' ) ) {
				masthead.classList.add( 'is-sticky' );
				requestAnimationFrame( function () {
					document.body.style.paddingTop = masthead.offsetHeight + 'px';
				} );
			}
		} else {
			masthead.classList.remove( 'is-sticky' );
			document.body.style.paddingTop = '';
		}
	}, { passive: true } );
}() );
